import { render, staticRenderFns } from "./SponsorBadge.vue?vue&type=template&id=5f738ad0&scoped=true&"
import script from "./SponsorBadge.vue?vue&type=script&lang=js&"
export * from "./SponsorBadge.vue?vue&type=script&lang=js&"
import style0 from "./SponsorBadge.vue?vue&type=style&index=0&id=5f738ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f738ad0",
  null
  
)

export default component.exports